import React, { useEffect } from 'react'
import Banner from '../pages/AuthPage/Banner'

const WithoutNav = () => {
    useEffect(() => {
        // Remove client stylesheets when component mounts
        const clientStylesheets = [
            "assets1/css/vendor/bootstrap.min.css",
            "assets1/css/vendor/slick.css",
            "assets1/css/vendor/slick-theme.css",
            "assets1/css/plugins/sal.css",
            "assets1/css/plugins/feather.css",
            "assets1/css/plugins/fontawesome.min.css",
            "assets1/css/plugins/euclid-circulara.css",
            "assets1/css/plugins/swiper.css",
            "assets1/css/plugins/magnify.css",
            "assets1/css/plugins/odometer.css",
            "assets1/css/plugins/animation.css",
            "assets1/css/plugins/bootstrap-select.min.css",
            "assets1/css/plugins/jquery-ui.css",
            "assets1/css/plugins/magnigy-popup.min.css",
            "assets1/css/plugins/plyr.css",
            "assets1/css/style.css"
        ];

        // Find and remove client stylesheets
        const links = document.getElementsByTagName('link');
        for (let i = links.length - 1; i >= 0; i--) {
            const link = links[i];
            if (clientStylesheets.some(stylesheet => link.href.includes(stylesheet))) {
                link.parentNode.removeChild(link);
            }
        }
    }, []);

    return <Banner />;
};

export default WithoutNav;